
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.32 13.32v-1.64h-2.5v-2.5H6.18v2.5h-2.5v1.64h2.5v2.5h1.64v-2.5h2.5zM4.422 5v1.68h5.156V5c0-.703-.26-1.302-.781-1.797-.495-.52-1.094-.781-1.797-.781-.703 0-1.315.26-1.836.781A2.447 2.447 0 004.422 5zM12 6.68c.443 0 .833.169 1.172.508.338.312.508.69.508 1.132v8.36c0 .442-.17.833-.508 1.172-.339.312-.73.468-1.172.468H2c-.443 0-.833-.156-1.172-.468-.338-.339-.508-.73-.508-1.172V8.32c0-.442.17-.82.508-1.133.339-.338.73-.507 1.172-.507h.82V5c0-1.146.404-2.122 1.211-2.93C4.865 1.237 5.854.82 7 .82s2.122.417 2.93 1.25c.833.808 1.25 1.784 1.25 2.93v1.68H12z","fill":"currentColor"}})])
          )
        }
      }
    